/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForReactiveTask extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForReactiveTask");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForReactiveTask.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForReactiveTask>): BackgroundJobPayloadForReactiveTask {
        let obj = Object.assign(new BackgroundJobPayloadForReactiveTask(), model);
        BackgroundJobPayloadForReactiveTask.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForReactiveTask>): BackgroundJobPayloadForReactiveTask {
        if (!model) return null;
        return BackgroundJobPayloadForReactiveTask.newInstance(<BackgroundJobPayloadForReactiveTask> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForReactiveTask) {
        if (!obj) return;

        models.BackgroundJobPayloadForReactiveTask.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForReactiveTask): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForReactiveTask.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
